import React from "react";
import Heading from "../../components/common/Typography/Heading";
import CountUp from "react-countup";
import SpecialText from "../../components/common/Typography/SpecialText";

const Percentaging = ({textColor, number, text}) => {
  return (
    <>
      <div>
        <SpecialText
          variant={"number-3xl"}
          className={`text-center animated-text ${textColor}`}
        >
          <CountUp start={0} end={number} delay={5}/>%
        </SpecialText>
        <SpecialText
          variant={"IntroParagraph"}
          className={"text-center text-offblack mt-3"}
        >
          {text}
        </SpecialText>
      </div>
    </>
  );
};

export default Percentaging;
